import { TranslationKeys } from './translationKeys';
import { ValidationType } from './validationType';

export const NotificationByCode = {
  [ValidationType.InvalidToken]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidSpin]: TranslationKeys.InvalidOperation,
  [ValidationType.MoneyTransactionError]: TranslationKeys.BetNotAccepted,
  [ValidationType.NotEnoughMoney]: TranslationKeys.NotEnoughMoney,
  [ValidationType.InvalidOperation]: TranslationKeys.BetNotAccepted,
  [ValidationType.SpinNotFound]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidSpinCount]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidAmount]: TranslationKeys.BetNotAccepted,
  [ValidationType.PartnerNotFound]: TranslationKeys.BetNotAccepted,
  [ValidationType.Success]: TranslationKeys.BetIsAccepted,
  [ValidationType.BonusNotFound]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidSpinResult]: TranslationKeys.BetNotAccepted,
  [ValidationType.BonusAlreadyExists]: TranslationKeys.BetNotAccepted,
  [ValidationType.PlayerLimitExceeded]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidRange]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidIndex]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidData]: TranslationKeys.BetNotAccepted,
  [ValidationType.InvalidSpinData]: TranslationKeys.BetNotAccepted,
  [ValidationType.MaxBetLimit]: TranslationKeys.MaxBetLimit,
  [ValidationType.InsufficientBalance]: TranslationKeys.InsufficientBalance,
  [ValidationType.MaintenanceNotify]: TranslationKeys.MaintenanceNotify,
  [ValidationType.FreeBetError]: TranslationKeys.FreeBetError,
  [ValidationType.GameReturnedNotify]: TranslationKeys.GameReturnedNotify,
};
